import React, { useState } from 'react';
import './ProDevelopment.css';

const ProDevelopment = () => {
  const [activeId, setActiveId] = useState(null);

  const certifications = [
    {
      id: "comptia-sec",
      title: "CompTIA Security+ (SY0-701)",
      image: "/images/CompTIAPlus.png",
      steps: [
        "Register on CompTIA's website (US or Canada)",
        "Purchase exam voucher (~$404 USD + taxes if applicable)",
        "Schedule exam with Pearson VUE",
        "Complete exam (90 questions, 90 minutes)"
      ],
      additionalInfo: "https://www.comptia.org/certifications/security",
      requirements: [
        "No formal prerequisites",
        "Network+ or equivalent recommended",
        "2 years of IT security experience (recommended)"
      ],
      resources: [
        "CompTIA’s official exam objectives (SY0-701)",
        "Professor Messer’s Security+ videos",
        "Mike Meyers’ Security+ course",
        "Practice exams (e.g., MeasureUp or Wiley)",
        "Hands-on labs (e.g., CertMaster Labs, TryHackMe basics)"
      ],
      readinessChecklist: [
        { criteria: "Network Fundamentals", weight: 85 },
        { criteria: "Security Concepts", weight: 90 },
        { criteria: "Access Management", weight: 75 },
        { criteria: "Cryptography Basics", weight: 80 }
      ]
    },
    {
      id: "oscp",
      title: "Offensive Security OSCP",
      image: "/images/OSCP.jpg",
      steps: [
        "Enroll in PEN-200 (Offensive Security) (US or Canada)",
        "Complete lab exercises and materials",
        "Schedule 24-hour online exam",
        "Pass the exam + submit detailed report"
      ],
      additionalInfo: "https://www.offensive-security.com/pwk-oscp/",
      requirements: [
        "No strict prerequisite, but Linux/Networking fundamentals recommended",
        "Basic scripting abilities",
        "Strong enumeration and exploitation skills"
      ],
      resources: [
        "OffSec PEN-200 course PDF and videos",
        "Practice labs (OffSec labs, HackTheBox, TryHackMe)",
        "Buffer Overflow tutorials (e.g., corelan.be)",
        "AD exploitation references (for updated OSCP)"
      ],
      readinessChecklist: [
        { criteria: "Linux Proficiency", weight: 95 },
        { criteria: "Enumeration Skills", weight: 90 },
        { criteria: "Buffer Overflow", weight: 85 },
        { criteria: "Privilege Escalation", weight: 90 }
      ]
    },
    {
      id: "osce",
      title: "Offensive Security OSCE³ (Advanced Certs)",
      image: "/images/OSCE.png",
      steps: [
        "Achieve OSCP or equivalent skill (US or Canada)",
        "Pursue OSEP (PEN-300), OSWE (WEB-300), OSED (EXP-301)",
        "Pass each 48-hour exam + submit reports",
        "Earn OSCE³ upon completing all three"
      ],
      additionalInfo: "https://www.offsec.com/certificates/osce3/",
      requirements: [
        "OSCP-level skills (strong pen testing background)",
        "Advanced exploit dev, AD and web hacking knowledge (depending on cert track)",
        "Assembly, debugging, advanced enumeration"
      ],
      resources: [
        "OffSec official courses (PEN-300, WEB-300, EXP-301)",
        "Practical labs (OffSec, HackTheBox, VulnHub)",
        "Assembly/Exploit Dev references (corelan, FuzzySecurity, etc.)"
      ],
      readinessChecklist: [
        { criteria: "Exploit Development", weight: 95 },
        { criteria: "Assembly Knowledge", weight: 90 },
        { criteria: "Debugging Skills", weight: 90 },
        { criteria: "Windows Internals", weight: 85 }
      ]
    },
    {
      id: "oswp",
      title: "Offensive Security OSWP",
      image: "/images/OSWP.webp",
      steps: [
        "Access WiFu (PEN-210) through OffSec subscription (US or Canada)",
        "Practice Wi-Fi hacking with lab setups",
        "Schedule 3-hour remote exam",
        "Submit detailed exam report"
      ],
      additionalInfo: "https://www.offsec.com/courses/pen-210/",
      requirements: [
        "Basic networking knowledge",
        "Linux familiarity",
        "Understanding of wireless security fundamentals"
      ],
      resources: [
        "PEN-210 (WiFu) course PDF/videos",
        "Aircrack-ng documentation",
        "Set up your own wireless practice lab",
        "Online community write-ups"
      ],
      readinessChecklist: [
        { criteria: "Wireless Fundamentals", weight: 85 },
        { criteria: "Tool Proficiency (aircrack-ng)", weight: 80 },
        { criteria: "Protocol Knowledge (802.11)", weight: 90 },
        { criteria: "Linux Skills", weight: 75 }
      ]
    },
    {
      id: "gfact",
      title: "GIAC Fundamentals of Cybersecurity Technologies (GFACT)",
      image: "/images/GFACT.png",
      steps: [
        "Register for exam (~$999 USD + taxes if applicable)",
        "Receive or prepare study materials (SANS SEC275 recommended)",
        "Create exam index (open-book exam)",
        "Schedule via Pearson VUE or ProctorU",
        "Complete 2-hour, 75-question exam (71% passing score)"
      ],
      additionalInfo: "https://www.giac.org/certifications/foundational-cybersecurity-technologies-gfact/",
      requirements: [
        "No formal prerequisites",
        "Basic IT knowledge recommended",
        "Familiarity with networking, OS, security concepts"
      ],
      resources: [
        "SANS SEC275 (Foundations) materials",
        "GIAC official practice exams",
        "Index creation guides",
        "Supplement with basic IT security textbooks"
      ],
      readinessChecklist: [
        { criteria: "Security Fundamentals", weight: 80 },
        { criteria: "Networking Basics", weight: 75 },
        { criteria: "Security Tools", weight: 70 },
        { criteria: "Terminology", weight: 85 }
      ]
    },
    {
      id: "gpen",
      title: "GIAC Penetration Tester (GPEN)",
      image: "/images/GPEN.png",
      steps: [
        "Register for exam (~$999 USD + taxes if applicable)",
        "Study with SANS SEC560 or equivalent materials",
        "Create exam index (open-book)",
        "Schedule exam (Pearson VUE or ProctorU)",
        "Pass 82-question, 3-hour exam (75% score)"
      ],
      additionalInfo: "https://www.giac.org/certifications/penetration-tester-gpen/",
      requirements: [
        "No strict prerequisite, but pen testing experience recommended",
        "Familiarity with tools (Nmap, Metasploit, etc.)",
        "Networking, scripting, web basics"
      ],
      resources: [
        "SANS SEC560 course books",
        "GIAC practice exams",
        "Pentest cheat sheets (SANS, community)",
        "Hands-on labs (HackTheBox, VulnHub, etc.)"
      ],
      readinessChecklist: [
        { criteria: "Penetration Testing", weight: 90 },
        { criteria: "Network Security", weight: 85 },
        { criteria: "Security Tools", weight: 90 },
        { criteria: "Web Security", weight: 85 }
      ]
    },
    {
      id: "gmon",
      title: "GIAC Continuous Monitoring Certification (GMON)",
      image: "/images/GMON.png",
      steps: [
        "Register for exam (~$999 USD + taxes if applicable)",
        "Study with SANS SEC511 or equivalent",
        "Create exam index (open-book)",
        "Schedule exam",
        "Pass 82-question, 3-hour exam (74% score)"
      ],
      additionalInfo: "https://www.giac.org/certifications/continuous-monitoring-certification-gmon/",
      requirements: [
        "Experience in security monitoring/incident response recommended",
        "Familiarity with SIEM, log analysis, Windows/Linux basics"
      ],
      resources: [
        "SANS SEC511 course materials",
        "GIAC practice exams",
        "Monitoring & incident response labs",
        "Log analysis references"
      ],
      readinessChecklist: [
        { criteria: "Monitoring Skills", weight: 90 },
        { criteria: "Tool Proficiency (SIEM, etc.)", weight: 85 },
        { criteria: "Log Analysis", weight: 90 },
        { criteria: "Incident Response", weight: 85 }
      ]
    },
    {
      id: "gxpn",
      title: "GIAC Exploit Researcher and Advanced Penetration Tester (GXPN)",
      image: "/images/GXPN.png",
      steps: [
        "Register for exam (~$1299 USD + taxes if applicable)",
        "Study advanced topics (SANS SEC660)",
        "Create detailed index (open-book)",
        "Schedule exam",
        "Pass 60-question, 3-hour exam (67% score)"
      ],
      additionalInfo: "https://www.giac.org/certifications/exploit-researcher-advanced-penetration-tester-gxpn/",
      requirements: [
        "Advanced exploit dev and pen testing experience",
        "Low-level programming (C/Assembly), debug tools",
        "Strong understanding of modern OS security"
      ],
      resources: [
        "SANS SEC660 materials",
        "Corelan exploit dev tutorials",
        "Practice with advanced lab environments (VulnHub, etc.)",
        "GIAC practice tests, official references"
      ],
      readinessChecklist: [
        { criteria: "Exploit Development", weight: 95 },
        { criteria: "Advanced Networking", weight: 90 },
        { criteria: "Reverse Engineering", weight: 90 },
        { criteria: "Programming Skills", weight: 85 }
      ]
    },
    {
      id: "rapid-insightvm",
      title: "Vulnerability Management: InsightVM Certified Administrator",
      image: "/images/InsightVM_Adminstrator.png",
      steps: [
        "Enroll in Rapid7 InsightVM course or self-study documentation (US or Canada)",
        "Purchase exam (~$215 USD + taxes if applicable)",
        "Complete training or product practice in a real environment",
        "Take online open-book exam (2 hours)",
        "Achieve ~80% score to pass"
      ],
      additionalInfo: "https://academy.rapid7.com/page/rapid7-certified-professional",
      requirements: [
        "Familiarity with vulnerability management concepts",
        "Hands-on experience using InsightVM/Nexpose"
      ],
      resources: [
        "Rapid7 InsightVM Admin Guide",
        "Official Rapid7 Academy training (virtual or in-person)",
        "Hands-on practice in InsightVM console",
        "User forums and knowledge base"
      ],
      readinessChecklist: [
        { criteria: "Scan Configuration & Management", weight: 85 },
        { criteria: "Reporting & Risk Scoring", weight: 80 },
        { criteria: "Remediation Workflow", weight: 85 },
        { criteria: "Tool Proficiency (UI & Features)", weight: 80 }
      ]
    },
    {
      id: "rapid-insightidr",
      title: "Detection and Response: InsightIDR Certified Specialist",
      image: "/images/InsightIDR.png",
      steps: [
        "Enroll in Rapid7 InsightIDR course or self-study docs (US or Canada)",
        "Purchase exam (~$215 USD + taxes if applicable)",
        "Familiarize with incident detection & response workflows",
        "Take online open-book exam (2 hours)",
        "Pass with ~80% score"
      ],
      additionalInfo: "https://academy.rapid7.com/page/rapid7-certified-professional",
      requirements: [
        "General SOC and IR knowledge recommended",
        "Hands-on experience with InsightIDR platform"
      ],
      resources: [
        "InsightIDR User & Admin Guide",
        "Rapid7 Academy or official training materials",
        "Practice environment for alerts, investigations",
        "Community forums, knowledge base"
      ],
      readinessChecklist: [
        { criteria: "Incident Detection Setup", weight: 85 },
        { criteria: "Log Analysis & Alerting", weight: 80 },
        { criteria: "Investigation Workflows", weight: 85 },
        { criteria: "Tool Proficiency", weight: 80 }
      ]
    },
    {
      id: "rapid-insightconnect",
      title: "SOC Automation: InsightConnect Certified Specialist",
      image: "/images/InsightConnect.png",
      steps: [
        "Register for InsightConnect training or self-study resources (US or Canada)",
        "Purchase exam (~$215 USD + taxes if applicable)",
        "Learn workflow automation, plugin usage",
        "Take online open-book exam (2 hours)",
        "Pass with ~80% score"
      ],
      additionalInfo: "https://academy.rapid7.com/page/rapid7-certified-professional",
      requirements: [
        "Familiarity with SOC processes and basic scripting",
        "Experience using InsightConnect for security automation"
      ],
      resources: [
        "InsightConnect documentation & tutorials",
        "Rapid7 Academy for SOC Automation",
        "Hands-on practice building workflows",
        "Community forums / plugin reference"
      ],
      readinessChecklist: [
        { criteria: "Automation Workflow Design", weight: 85 },
        { criteria: "Plugin Integration", weight: 80 },
        { criteria: "Scripting & API Knowledge", weight: 75 },
        { criteria: "Tool Proficiency (InsightConnect)", weight: 85 }
      ]
    },
    {
      id: "ceh",
      title: "EC-Council Certified Ethical Hacker (CEH v13)",
      image: "/images/CEH.png",
      steps: [
        "Confirm eligibility: 2 years InfoSec experience or official training (US or Canada)",
        "Purchase exam voucher (~$950-$1199 USD + taxes if applicable)",
        "Schedule exam via Pearson VUE or ECC Exam",
        "Complete 4-hour, 125-question exam",
        "Maintain via EC-Council ECE credits"
      ],
      additionalInfo: "https://www.eccouncil.org/certified-ethical-hacker-ceh/",
      requirements: [
        "2 years InfoSec experience or CEH official training",
        "Networking, OS knowledge",
        "Basic hacking concepts"
      ],
      resources: [
        "EC-Council official courseware / iLabs",
        "CEH All-in-One by Matt Walker",
        "Boson or official practice exams",
        "Hands-on labs with Metasploitable, etc."
      ],
      readinessChecklist: [
        { criteria: "Security Fundamentals", weight: 85 },
        { criteria: "Networking Knowledge", weight: 80 },
        { criteria: "Tool Proficiency", weight: 85 },
        { criteria: "OS Understanding", weight: 80 }
      ]
    },
    {
      id: "cpent",
      title: "EC-Council Certified Penetration Testing Professional (CPENT)",
      image: "/images/CPENT.jpeg",
      steps: [
        "Recommended: CEH certification or official CPENT training (US or Canada)",
        "Register for CPENT exam (~$999 USD + taxes if applicable)",
        "Complete the 24-hour practical exam remotely",
        "Submit penetration test report",
        "Score ≥90% for LPT (Master); ≥70% for CPENT"
      ],
      additionalInfo: "https://www.eccouncil.org/train-certify/certified-penetration-testing-professional-cpent/",
      requirements: [
        "CEH-level knowledge recommended",
        "Advanced pen test, exploit dev, AD attacks, IoT hacking"
      ],
      resources: [
        "EC-Council’s CPENT official course",
        "Hands-on labs (CPENT practice range, HackTheBox, etc.)",
        "OffSec OSCP/OSEP references for advanced topics",
        "Reporting best practices for pen tests"
      ],
      readinessChecklist: [
        { criteria: "Network & Web Exploits", weight: 90 },
        { criteria: "Binary Exploits", weight: 85 },
        { criteria: "Pivoting & Evasion", weight: 90 },
        { criteria: "Documentation & Reporting", weight: 85 }
      ]
    },
    {
      id: "lpt",
      title: "EC-Council Licensed Penetration Tester (LPT) (Master)",
      image: "/images/LPT.png",
      steps: [
        "Achieve ≥90% on the CPENT 24-hour exam (US or Canada)",
        "Submit final report for assessment",
        "Receive LPT (Master) recognition"
      ],
      additionalInfo: "https://www.eccouncil.org/programs/licensed-penetration-tester-lpt-master/",
      requirements: [
        "In-depth expertise in pen testing (network, web, IoT, AD)",
        "Experience with exploit dev and advanced reporting"
      ],
      resources: [
        "Same resources as CPENT",
        "Strong practical experience with advanced attacks",
        "Official LPT (Master) benefits and community"
      ],
      readinessChecklist: [
        { criteria: "Advanced Exploitation", weight: 95 },
        { criteria: "Report Writing", weight: 90 },
        { criteria: "Time Management (24hr exam)", weight: 85 },
        { criteria: "Problem Solving", weight: 90 }
      ]
    }
  ];
  

  const ReadinessIndicator = ({ criteria, weight }) => (
    <div className="prodev10-readiness-item">
      <div className="prodev10-progress-header">
        <span>{criteria}</span>
        <span>{weight}%</span>
      </div>
      <div className="prodev10-progress-bar">
        <div 
          className="prodev10-progress-fill"
          style={{ width: `${weight}%` }}
        />
      </div>
    </div>
  );

  const toggleAccordion = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <div className="prodev10-container">
      <h1 className="prodev10-title">Professional Development</h1>
      
      <div className="prodev10-accordion">
        {certifications.map((cert) => (
          <div key={cert.id} className="prodev10-accordion-item">
            <div 
              className="prodev10-accordion-header"
              onClick={() => toggleAccordion(cert.id)}
            >
              <img 
                src={cert.image} 
                alt={cert.title} 
                className="prodev10-cert-image"
              />
              <span className="prodev10-cert-title">{cert.title}</span>
              <span className={`prodev10-accordion-icon ${activeId === cert.id ? 'active' : ''}`}>
                ▼
              </span>
            </div>
            
            <div className={`prodev10-accordion-content ${activeId === cert.id ? 'active' : ''}`}>
                <div className="prodev10-grid">
                    <div className="prodev10-steps">
                        <h3>Certification Steps</h3>
                        {/* Combined steps for US/Canada into one list */}
                        <ul>
                            {cert.steps.map((step, idx) => (
                            <li key={idx}>{step}</li>
                            ))}
                        </ul>

                        {/* New section for the additional info link */}
                        <div className="prodev10-subsection">
                            <strong>Additional Info: </strong>
                            <a 
                            href={cert.additionalInfo} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            >
                            {cert.additionalInfo}
                            </a>
                        </div>
                    </div>
                    
                    <div className="prodev10-requirements">
                        <h3>Required Knowledge</h3>
                        <ul>
                        {cert.requirements.map((req, idx) => (
                            <li key={idx}>{req}</li>
                        ))}
                        </ul>
                        
                        <h3>Study Resources</h3>
                        <ul>
                        {cert.resources.map((resource, idx) => (
                            <li key={idx}>{resource}</li>
                        ))}
                        </ul>
                    </div>
                    
                    <div className="prodev10-readiness">
                        <h3>Readiness Assessment</h3>
                        <div className="prodev10-readiness-grid">
                        {cert.readinessChecklist.map((item, idx) => (
                            <ReadinessIndicator key={idx} {...item} />
                        ))}
                        </div>
                    </div>
                </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProDevelopment;